import { IApplicationState } from '../../types/redux';
import { selectJsonQuery } from '../jsonQuery';

export const selectTrackingPromoSearch = (state: IApplicationState) => {
  const sc = selectJsonQuery(state);

  return {
    sc,
  };
};
